import CarouselPreview from 'components/messagePreview/components/CarouselPreview';
import SuggestedActionsPreview from 'components/messagePreview/components/SuggestedActionsPreview';
import { RcsMessage, RcsMessageCard } from 'types/rcs';

const LOADING_CARDS: RcsMessageCard[] = [
  { text: 'Loading...', title: '', buttons: [], url: '' },
];

interface RcsCarouselPreviewProps {
  cards: RcsMessageCard[];
  carouselOverflowSize?: string;
  isLoading: boolean;
  message: RcsMessage;
}

const RcsCarouselPreview = ({
  cards,
  carouselOverflowSize,
  isLoading,
  message,
}: RcsCarouselPreviewProps) => {
  return (
    <>
      <CarouselPreview
        cards={isLoading ? LOADING_CARDS : cards}
        overflowSize={carouselOverflowSize}
      />
      <SuggestedActionsPreview suggestedActions={message.suggestedActions} />
    </>
  );
};

export default RcsCarouselPreview;
